import _ from "lodash";

const isEmpty = (value) => {
  if (!value) return false;
  if (Array.isArray(value)) return Boolean(value.length);
  return value ? Boolean(Object.keys(value).length) : false;
};

const isArrayEmpty = (value) => {
  if (_.isEmpty(value)) {
    return true;
  }
  return false;
}

const isNotEmpty = value => isEmpty(value);

const clone = (value) => {
  if (!value) return value;
  const isObject = (typeof value === 'object');
  const isArray = Array.isArray(value);
  if (!isObject && !isArray) return value;
  // Removing reference of Array of values
  return _.cloneDeep(value)
};

const merge = (parent, values) => ({ ...parent, ...values });

export {
  isEmpty,
  isNotEmpty,
  clone,
  merge,
  isArrayEmpty
};
